import { Component, OnInit } from '@angular/core';
import { UserService, JwtService, PatientService, FormSessionCanDeactivate } from '../shared';
import { environment } from '../shared/config/app-config';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-styker-login',
  templateUrl: './styker-login.component.html',
  styleUrls: ['./styker-login.component.css']
})
export class StykerLoginComponent {
  currentUser: any;
  dateValidation: any = false;
  imageURL: string = environment.cloudeImageURL;
  dateformat: any;


  constructor(private Userservice: UserService, private patientservice: PatientService, private router: Router) { }

  ngOnInit() {


    this.Userservice.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        this.currentUser.status = true;
        if (this.currentUser.item) {
          //this.setmask = this.currentUser.item.phoneFormat.split('#').join('0');
          if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
          } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
          }
          //this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue',showWeekNumbers: false,dateInputFormat: this.dateformat});
        }
      });

    if (this.currentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;
  }


  demoSetup() {
    this.currentUser.item.superClient = false
    this.currentUser.item.allowOnboard = false
    window.localStorage.removeItem('superClientId')
    window.localStorage.removeItem('stykerAdminUser')
    window.localStorage.removeItem('adminnamefname')
    window.localStorage.removeItem('adminnamelname')
    window.localStorage['adminnamefname'] = this.currentUser.item.firstName
    window.localStorage['adminnamelname'] = this.currentUser.item.lastName
    window.localStorage['stykerAdminUser'] = this.currentUser.item.userId
    this.Userservice.setAuth(this.currentUser);

  }


  clientLogin() {
    window.localStorage.removeItem('superClientId')
    window.localStorage.removeItem('stykerAdminUser')
    window.localStorage.removeItem('adminnamefname')
    window.localStorage.removeItem('adminnamelname')
    this.router.navigateByUrl('/clientSetup');
  }


  rcOnboard() {
    window.localStorage.removeItem('superClientId')
    window.localStorage.removeItem('stykerAdminUser')
    window.localStorage.removeItem('adminnamefname')
    window.localStorage.removeItem('adminnamelname')
    //this.router.navigateByUrl('/login');

    this.patientservice.getPatientPassword(this.currentUser.item.userId, this.currentUser.item.userAccountId).subscribe(data => {
      ////console.log(data)
      if (data.item.status == 'success') {
        var userEnc = encodeURIComponent(btoa(data.item.uname));
        var pasEnc = encodeURIComponent(data.item.pwd);
        window.location.href = environment.directobgin_url + '/#/oblogin/' + userEnc + "/" + pasEnc + "/";
      }
    })
  }

  logout() {
    this.Userservice.logoutuser(this.currentUser.item.useAccountId)
    this.Userservice.purgeAuth();
    if (window.localStorage['plogin']) {
      var plogin = window.localStorage['plogin']
      window.localStorage.removeItem('plogin');
      //window.localStorage.clear()
      this.router.navigateByUrl('/plogin/' + plogin);

    } else {
      //this.currentUser.status==false
      //window.localStorage.clear()
      this.router.navigateByUrl('/login');
    }
  }
  getFullYear() {
    return new Date().getFullYear();
  }
}
